//#region src/lib/utils.js
/**
* Map of prefixes with their current 'id' numbers.
* Used by `getUniqueString(...)`
*
* @type {object}
*/
var UNIQUE_ID_MAP = {};
/**
* Gets the next string value given a prefix.
*
* @param {string} prefix - The prefix that will be uniquely incremented.
* @returns {string} The next unique string for given prefix.
*/
function getUniqueString(prefix = "dtc") {
	let id = UNIQUE_ID_MAP[prefix];
	if (!id) {
		id = 0;
		UNIQUE_ID_MAP[prefix] = id;
	}
	return `${prefix}${UNIQUE_ID_MAP[prefix]++}`;
}
/**
* Gets specific type name from a value, intended to be used with value from a 'member'.
* Gives some more specific type names such as 'array' etc...
*
* @param {*} value - The value.
* @returns {string|null} The specific member type.
*/
function typeOfMemberValue(value) {
	if (value === void 0 || value === null) return null;
	const type = typeof value;
	switch (type) {
		case "symbol": return value.toString();
		case "object": return Array.isArray(value) ? "array" : "object";
		default: return type;
	}
}
/**
* Enumerates an object that contains key-value pairs, each containing an array.
* A handler is called for each item in each array.
*
* The first parameter for the handler is the key for the array that the item is in.
* The second parameter for the handler is the item in the array.
*
* Used to make enumerating through the 'options' and 'info' members easier.
*
* @param {Function} handler - The handler called for each entry.
* @param {object} groups - Object that contains key-value pairs, each containing an array.
*/
function enumerateGroups(handler, groups) {
	Object.entries(groups).forEach(([group, entries]) => {
		entries?.forEach((entry) => {
			handler(group, entry);
		});
	});
}
//#endregion
export { enumerateGroups, getUniqueString, typeOfMemberValue };

//# sourceMappingURL=utils.js.map